import React, { useEffect, useState } from 'react'
import crosssimgiocn from "../../src/Images/crosssimgiocn.png";
import vectorarrow from "../../src/Images/vectorarrow.png"
import HttpClient from '../utils/HttpClient';
import Select from "react-select";
import { Autocomplete, TextField, Chip } from "@mui/material";
import { useDispatch, useSelector } from 'react-redux';
import { fetchMyBusinessPosts } from '../Redux/Slice/BusinessPostSlice';
import toast from 'react-hot-toast';

const selectStyles = {
    menu: (provided) => ({
        ...provided,
        zIndex: 2,
    }),
};

const BusinessPostModal = ({ closemodal }) => {
    const { UserProfileID } = useSelector((state) => state.app);
    const { status, MyBusinessPosts, } = useSelector((state) => state.post);
    const dispatch = useDispatch()

    const [selectedOptions, setSelectedOptions] = useState([])
    const [serviceOptions, setServiceOptions] = useState([])
    const [drowdowsncustom, setDrowdowsncustom] = useState(false)
    const drowdowncustclick = () => {
        setDrowdowsncustom(!drowdowsncustom)
    }

    const [ddlState, setDdlState] = useState(false)
    const ddlStateClick = () => {
        setDdlState(!ddlState)
    }
    const [ddlCountry, setDdlCountry] = useState(false)
    const ddlCountryClick = () => {
        setDdlCountry(!ddlCountry)
    }

    const initialPostData = {
        subject: "",
        description: "",
        file: "",
        targetAudience: [],
        searchKeywords: [],
        state: "",
        countryId: "", //65f95f070d6753c3bdacccd9
    };
    const [formData, setFormData] = useState(initialPostData);
    const [countryStates, setCountryStates] = useState([]);
    const [countries, setCountries] = useState([]);
    const [error, setError] = useState("");

    const getCountryStates = async () => {
        if (formData?.countryId === "all") {
            setFormData({ ...formData, state: "all" })
            setCountryStates([])
            return
        }
        try {
            const res = await HttpClient.requestData(
                "countrywise-state/" + formData?.countryId,
                "GET"
            );
            if (res?.status) {
                setCountryStates(res.data?.[0]?.states || []);
            }
        } catch (error) {
            console.error("Error fetching country states:", error);
        }
    };

    const getCountries = async () => {
        try {
            // const response = await HttpClient.requestData("countries-list", "GET");
            const response = await HttpClient.requestData("countries", "GET");
            if (response.status) {
                setCountries(response.data);
            }
        } catch (error) {
            console.error("Error fetching countries:", error);
        }
    };

    const getCompanyTypeWiseServices = async (id) => {
        try {
            const res = await HttpClient.requestData(
                // `companyType-wise-servicess/${id}`,
                'companyType',
                "GET"
            );

            if (res?.status) {

                const filteredData = res.data.filter(
                    // (item) => !UserProfileID?.businessProductCat.includes(item._id)
                    //   (item) => !services.includes(item._id)
                    (item) => item
                );

                setServiceOptions(filteredData.map((item) => ({
                    value: item._id,
                    label: item.type,
                })) || []);
            }
        } catch (error) {
            console.error("Error occured!", error);
        }
    };


    const [selectedKeywordOptions, setSelectedKeywordOptions] = useState([]);
    const handleChange = (event, newValue) => {
        setSelectedKeywordOptions(newValue);
    };
    const [keywordOptions, setKeywordOptions] = useState([])
    const getBusinessKeywords = async () => {
        try {
            const res = await HttpClient.requestData(
                "business-product-keywords",
                "GET"
            );

            if (res?.status) {
                const filteredData = res.data.filter(
                    // (item) => !UserProfileID?.businessProductkeywords.includes(item._id)
                    // (item) => !services.includes(item._id)
                    (item) => item
                );
                setKeywordOptions(filteredData || [])
            }
        } catch (error) {
            console.error("Error fetching country states:", error);
        }
    };

    useEffect(() => {
        getCompanyTypeWiseServices(UserProfileID?.companyTypeID)
        getBusinessKeywords()
        getCountries();
        getCountryStates();
    }, []);

    useEffect(() => {
        getCountryStates();
    }, [formData.countryId]);

    const handleServiceChange = (selected) => {
        setSelectedOptions(selected);
    };

    const _updateForm = (name, value) => {
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    ////////////////Word Limit
    const maxWords = 60;
    const maxWordsForSubject = 10;

    const updateForm = (key, value) => {
        const subjectWords = value.trim().split(/\s+/).filter(Boolean);
        const words = value.trim().split(/\s+/).filter(Boolean);
        if (key === "subject") {
            if (subjectWords.length <= maxWordsForSubject) {
                setFormData({ ...formData, [key]: value });
            }
        } else if (key === "description") {
            if (words.length <= maxWords) {
                setFormData({ ...formData, [key]: value });
            }
        }
        else {
            setFormData({ ...formData, [key]: value });
        }
    };

    const wordCountForSubject = formData.subject.trim().split(/\s+/).filter(Boolean).length;
    const wordsRemainingForSubject = maxWordsForSubject - wordCountForSubject;

    const wordCount = formData.description.trim().split(/\s+/).filter(Boolean).length;
    const wordsRemaining = maxWords - wordCount;

    const [fileName, setFileName] = useState("");
    const [attachmentUploading, setAttachmentUploading] = useState(false)

    const imageUpload = async (file) => {
        if (!file) return; // Ensure there is a file to upload
        setError("");
        setAttachmentUploading(true);
        const formData = new FormData();
        formData.append("image", file);

        try {
            const res = await HttpClient.fileUploadWithoutAuth("image-upload", "POST", formData);
            if (res.status) {
                updateForm("file", res.data.url)
            } else {
                setError(res?.message || "Error while uploading image");
                toast.error(res?.message || "Error while uploading image");
                console.log("Error while uploading image");
            }
        } catch (error) {
            setError("Error while uploading image");
            toast.error("Error while uploading image");
            console.error("Upload failed:", error);
        } finally {
            setAttachmentUploading(false);
        }
    };

    const [uploadedFilePreview, setUploadedFilePreview] = useState("No file chosen")
    const handleFileChange = (event) => {
        if (event.target.files && event.target.files.length > 0) {
            const file = event.target.files[0];
            // Validate file type
            const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
            if (!validImageTypes.includes(file.type)) {
                setError("Error: Please upload a valid image file (PNG/JPEG)");
                toast.error("Error: Please upload a valid image file (PNG/JPEG)");
                return;
            }

            // Validate file size (5MB = 5242880 bytes)
            const maxSize = 5 * 1024 * 1024;
            if (file.size > maxSize) {
                setError("Error: File size must be less than or equal to 5MB");
                toast.error("Error: File size must be less than or equal to 5MB");
                return;
            }

            setFileName(file.name);
            setUploadedFilePreview(file.name)
            imageUpload(file);
        } else {
            // setFileName("No file chosen");
            setUploadedFilePreview("No file chosen")
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault()
        const data = {
            ...formData,
            targetAudience: selectedOptions.map((item) => item.label),
            targetAudienceId: selectedOptions.map((item) => item.value),
            searchKeywords: selectedKeywordOptions.map((item) => item.keyword),
            searchKeywordsId: selectedKeywordOptions.map((item) => item._id),
            countryId: formData?.countryId === "all" || formData?.countryId === "" ? "" : formData?.countryId,
            state: formData?.state === "all" || formData?.state === "" ? "" : formData?.state,
        }

        if (!formData.subject) {
            toast.error("Please enter title");
        } else if (!formData.description) {
            toast.error("Please enter description");
        } else if (!formData.countryId) {
            toast.error("Please select country");
        } else if (!formData.state) {
            toast.error("Please select state");
        } else {

            try {
                const response = await HttpClient.requestData(
                    "post-upload",
                    "POST",
                    data
                );
                if (response.status) {

                } else {
                    console.error("Error in Post");
                }
            } catch (error) {
                console.error("Error submitting Post:", error);
            } finally {
                dispatch(fetchMyBusinessPosts())
                closemodal()
            }
        }
    }

    return (
        <div className='uploabannermodalbgshadow'>
            <div className='enquerysmokdnndbndbg'>
                <h5 className="mt-2 p-0 m-3">Post your updates</h5>
                <div className="crossdivicon" onClick={() => closemodal()} style={{ cursor: "pointer" }}>
                    <i className="fa-solid fa-xmark"></i>
                </div>
                <hr />

                <div className="psendwendijndwjjwndiv">
                    {/* <p className="breyuuayproosttxppp">Post your updates</p> */}

                    <div className='poysttdiobnnnmmmnjm'>
                        <p className='conattaindptxtppnewallasa'>Title <span> *</span></p>
                        <input type="text" placeholder="Enter a subject for your post" className="inpustxocntbusuitxtppnewallattyy"
                            value={formData.subject || ""}
                            onChange={(e) => updateForm("subject", e.target.value)}
                        />
                        <p style={{ fontSize: '13px', float: "right", color: wordsRemainingForSubject === 0 ? 'red' : 'gray' }}>
                            ({wordsRemainingForSubject} - {maxWordsForSubject})
                        </p>
                    </div>


                    <div className='poysttdiobnnnmmmnjm'>
                        <p className='conattaindptxtppnewallasa'>Description <span> *</span></p>
                        {/* <textarea rows={4} cols={4} className='ennsjjuwtysttsxttaytredg'
                            placeholder="Enter description..."
                            value={formData.description || ""}
                            onChange={(e) => updateForm("description", e.target.value)}
                        /> */}
                        <textarea
                            rows={4}
                            cols={4}
                            className="ennsjjuwtysttsxttaytredg"
                            placeholder="Enter description..."
                            value={formData.description}
                            onChange={(e) => updateForm("description", e.target.value)}
                        />
                        {/* <p style={{ fontSize: '13px', float: "right", color: wordsRemaining === 0 ? 'red' : 'gray' }}>
                            {wordsRemaining} word{wordsRemaining !== 1 ? 's' : ''} remaining
                        </p> */}
                        <p style={{ fontSize: '13px', float: "right", color: wordsRemaining === 0 ? 'red' : 'gray' }}>
                            ({wordsRemaining} - {maxWords})
                        </p>
                    </div>

                    {/* <div className='poysttdiobnnnmmmnjm'>
                        <p className='conattaindptxtppnewallasa'>Attachment <span>  </span></p>
                        <div className='chossefilkklkebdtrfdiv'>
                            <div className='enuqteyschosefllfbrdttdivdkdlnb'>
                                <button className='enuqteyschosefllfbrdtt'>
                                    Choose file
                                </button>
                                <p>No file chosen</p>
                            </div>
                        </div>
                    </div> */}

                    <div className='poysttdiobnnnmmmnjm'>
                        <p className='conattaindptxtppnewallasa'>Attachment <span></span></p>
                        <div className='chossefilkklkebdtrfdiv'>
                            <div className='enuqteyschosefllfbrdttdivdkdlnb'>
                                <div className="custom-file-upload">
                                    <label for="file-upload" className="file-label">
                                        Choose file
                                    </label>
                                    <input id="file-upload" type="file" accept="image/*" onChange={handleFileChange} />
                                    {/* <span id="file-chosen">{fileName}</span> */}
                                    <span id="file-chosen">{uploadedFilePreview}</span>
                                    {attachmentUploading ? <><span>Uploading...</span></> : formData?.file && <><img src={formData?.file} style={{ height: "72px" }} /></>}
                                </div>
                            </div>
                        </div>
                        <p className="error pl-4">{error != '' && error}</p>
                    </div>

                    <div className='poysttdiobnnnmmmnjm'>
                        <p className='conattaindptxtppnewallasa'>Target category <span>  </span></p>
                        {/* <div className='compamyupdatepoksttmodaldiv'>

                            <div className='compamydinfodivmdiobbdgppshgsadd'>

                                <div className='dropwdowndivfrmbusineenewwlas'>
                                    <p className='vectoraarowdivomgulmaili'>
                                        Advertising
                                    </p>
                                    <div className='vectoraarowdivomgnenwlal' onClick={drowdowncustclick}>
                                        <img src={vectorarrow} alt='...' />
                                    </div>
                                    {drowdowsncustom && <div className='vectoraarowdivomgulmai'>
                                        <ul className='vectoraarowdivomgulmaiul'>
                                            <li className='vectoraarowdivomgulmaili'>
                                                Advertising
                                            </li>
                                            <li className='vectoraarowdivomgulmaili'>
                                                Advertising
                                            </li>
                                            <li className='vectoraarowdivomgulmaili'>
                                                Advertising
                                            </li>
                                            <li className='vectoraarowdivomgulmaili'>
                                                Advertising
                                            </li>
                                            <li className='vectoraarowdivomgulmaili'>
                                                Advertising
                                            </li>
                                        </ul>
                                    </div>}
                                </div>
                            </div>

                            <div className='compamydinfodivmdiobbdgppshgsadd'>

                                <div className='dropwdowndivfrmbusineenewwlas'>
                                    <p className='vectoraarowdivomgulmaili'>
                                        Digital marketing
                                    </p>
                                    <div className='vectoraarowdivomgnenwlal' onClick={drowdowncustclick}>
                                        <img src={vectorarrow} alt='...' />
                                    </div>
                                    {drowdowsncustom && <div className='vectoraarowdivomgulmai'>
                                        <ul className='vectoraarowdivomgulmaiul'>
                                            <li className='vectoraarowdivomgulmaili'>
                                                Digital marketing
                                            </li>
                                            <li className='vectoraarowdivomgulmaili'>
                                                Digital marketing
                                            </li>
                                            <li className='vectoraarowdivomgulmaili'>
                                                Digital marketing
                                            </li>
                                            <li className='vectoraarowdivomgulmaili'>
                                                Digital marketing
                                            </li>
                                            <li className='vectoraarowdivomgulmaili'>
                                                Digital marketing
                                            </li>
                                        </ul>
                                    </div>}
                                </div>
                            </div>

                            <div className='compamydinfodivmdiobbdgppshgsadd'>

                                <div className='dropwdowndivfrmbusineenewwlas'>
                                    <p className='vectoraarowdivomgulmaili'>
                                        Digital marketing
                                    </p>
                                    <div className='vectoraarowdivomgnenwlal' onClick={drowdowncustclick}>
                                        <img src={vectorarrow} alt='...' />
                                    </div>
                                    {drowdowsncustom && <div className='vectoraarowdivomgulmai'>
                                        <ul className='vectoraarowdivomgulmaiul'>
                                            <li className='vectoraarowdivomgulmaili'>
                                                Digital marketing
                                            </li>
                                            <li className='vectoraarowdivomgulmaili'>
                                                Digital marketing
                                            </li>
                                            <li className='vectoraarowdivomgulmaili'>
                                                Digital marketing
                                            </li>
                                            <li className='vectoraarowdivomgulmaili'>
                                                Digital marketing
                                            </li>
                                            <li className='vectoraarowdivomgulmaili'>
                                                Digital marketing
                                            </li>
                                        </ul>
                                    </div>}
                                </div>
                            </div>
                        </div> */}
                        <Select
                            options={serviceOptions}
                            isMulti
                            value={selectedOptions}
                            onChange={handleServiceChange}
                            placeholder="Select type of busienss..."
                            styles={selectStyles}
                        />
                    </div>


                    <div className='poysttdiobnnnmmmnjm'>
                        <p className='conattaindptxtppnewallasa'>Search keywords <span>  </span></p>
                        {/* <div className='compamyupdatepoksttmodaldiv'>
                            <div className='compamydinfodivmdiobbdgppshgsadd'>

                                <input type="text" placeholder="Advertising" className="inpustxocntbusuitxtppnewallattyy" />
                            </div>
                            <div className='compamydinfodivmdiobbdgppshgsadd'>

                                <input type="text" placeholder="Advertising" className="inpustxocntbusuitxtppnewallattyy" />
                            </div>
                            <div className='compamydinfodivmdiobbdgppshgsadd'>

                                <input type="text" placeholder="Digital marketing" className="inpustxocntbusuitxtppnewallattyy" />
                            </div>


                        </div> */}
                        <Autocomplete
                            multiple
                            options={keywordOptions}
                            getOptionLabel={(option) => option.keyword}
                            value={selectedKeywordOptions}
                            onChange={handleChange}
                            isOptionEqualToValue={(option, value) => option._id === value._id}
                            renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                    <Chip
                                        key={option.id}
                                        label={option.keyword}
                                        {...getTagProps({ index })}
                                    />
                                ))
                            }
                            renderInput={(params) => (
                                <TextField {...params} label="Select keywords" placeholder="Type to search" />
                            )}
                        />
                    </div>

                    <div className='poysttdiobnnnmmmnjm'>
                        <div className='poysttdiobnnnmmmnjmdivflxs'>
                            <div className='compamydinfodivmdiobbdgppshg'>
                                <p className='conattaindptxtppnewallasa'>Country <span> * </span></p>
                                {/* <div className='dropwdowndivfrmbusineenewwlas'>
                                    <p className='vectoraarowdivomgulmaili'>
                                        United arab emirate
                                    </p>
                                    <div className='vectoraarowdivomgnenwlal' onClick={drowdowncustclick}>
                                        <img src={vectorarrow} alt='...' />
                                    </div>
                                    {ddlCountry && <div className='vectoraarowdivomgulmai'>
                                        <ul className='vectoraarowdivomgulmaiul'>
                                            {countries.filter((item) => item._id === "65f95f070d6753c3bdacccd9").map((country, index) => (
                                                <li
                                                    key={index}
                                                    className="vectoraarowdivomgulmaili"
                                                    onClick={() => {
                                                        // handleInputChange("state", state);
                                                        // toggleDropdown("state");
                                                        updateForm("countryId", country._id)
                                                        ddlCountryClick()
                                                    }}
                                                >
                                                    {country?.name}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>}
                                </div> */}
                                <select className="neooSelect"
                                    value={formData?.countryId}
                                    onChange={(e) => {
                                        updateForm("countryId", e.target.value)
                                        // handleInputChange("countryName", e.target.options[e.target.selectedIndex].text)
                                    }
                                    }
                                >
                                    <option value="">Choose...</option>
                                    <option value="all">All Countries</option>
                                    {
                                        countries
                                            // .filter(item => item._id === "65f95f070d6753c3bdacccd9")
                                            .map((item, key) => {
                                                return (
                                                    <><option value={item?._id}>{item?.name}</option></>
                                                )
                                            })
                                    }
                                    {/* <option value="United Arab Emirate">United Arab Emirate</option> */}
                                </select>
                            </div>

                            <div className='compamydinfodivmdiobbdgppshg'>
                                <p className='conattaindptxtppnewallasa'>State <span> * </span></p>
                                {/* <div className='dropwdowndivfrmbusineenewwlas'>
                                    {
                                        formData.state ? (
                                            <p className='vectoraarowdivomgulmaili'>
                                                {formData.state}
                                            </p>
                                        ) : (
                                            <p className='vectoraarowdivomgulmaili'>
                                                --- Choose ---
                                            </p>
                                        )
                                    }

                                    <div className='vectoraarowdivomgnenwlal' onClick={ddlStateClick}>
                                        <img src={vectorarrow} alt='...' />
                                    </div>
                                    {ddlState && <div className='vectoraarowdivomgulmai'>
                                        <ul className='vectoraarowdivomgulmaiul'>
                                            {countryStates.map((state, index) => (
                                                <li
                                                    key={index}
                                                    className="vectoraarowdivomgulmaili"
                                                    onClick={(e) => {
                                                        handleInputChange("state", state);
                                                        toggleDropdown("state");
                                                        updateForm("state", state?.name)
                                                        ddlStateClick()
                                                    }}
                                                >
                                                    {state?.name}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>}
                                </div> */}
                                <select className="neooSelect"
                                    name="state"
                                    value={formData.state}
                                    onChange={(e) =>
                                        updateForm("state", e.target.value)
                                    }
                                >
                                    <option value="">Choose...</option>
                                    <option value="all">All States</option>
                                    {
                                        countryStates?.map((item) => {
                                            return (
                                                <><option value={item.name}>{item.name}</option></>
                                            )
                                        })
                                    }
                                </select>
                            </div>


                        </div>
                    </div>

                    <div className="svavtatvvbtnnmdivmaokin">
                        <button className="svavtatvvbtnnmsendferdgf"
                            onClick={(e) => handleSubmit(e)}
                        >Post</button>
                    </div>
                </div>






            </div>
        </div>
    )
}

export default BusinessPostModal
